const url = window.location.hostname === "localhost" ? "allongekkia.com" : window.location.hostname
const domainName = 'AllongeApi'

export const ServerConfiguration = {
  APIServerUrl: `https://${url}/${domainName}/api/${domainName}/`,
}